import Styles from './FileCard.module.scss'
import { Download } from 'blaze-ui/icons'
import { DesignPreview } from 'api/clients/DesignClient'
import { Text } from 'blaze-ui/Text/Text'
import { usePress } from '@react-aria/interactions'
import cx from 'classnames'
import { ExportedFrame } from 'components/VisualStudioPlayground/VisualEditor/utils/export/exportDesign'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { bytesToMb } from 'blaze-components/MediaUploadModal/utils'
import { durationLabel } from 'components/VideoDuration/VideoDuration'

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      d="M12.355 6.33185C13.7054 7.10165 13.7054 9.02615 12.355 9.79595L3.40634 14.8969C2.05587 15.6667 0.367798 14.7045 0.367798 13.1649L0.367798 2.96294C0.367798 1.42334 2.05588 0.461094 3.40634 1.23089L12.355 6.33185Z"
      fill="white"
    />
  </svg>
)

interface Props {
  preview: DesignPreview
  designFile: ExportedFrame
  onPress: () => void
}

export const FileCard = observer(({ preview, designFile, onPress }: Props) => {
  const { designStore } = useRootStore()
  const { isPressed, pressProps } = usePress({ onPress })

  return (
    <div key={preview.url} className={cx(Styles.previewCard, { [Styles.pressed]: isPressed })} {...pressProps}>
      {preview.mime_type.includes('image') ? (
        <img src={preview.url} alt="preview" />
      ) : (
        <div className={Styles.videoContainer}>
          <img src={preview.still} alt="preview" />
          <div className={Styles.play}>
            <PlayIcon />
          </div>
        </div>
      )}
      <div className={Styles.metadataContainer}>
        <div className={Styles.metadataItem}>
          <Text variant="metadata" color="var(--dark-60)">
            Resolution:
          </Text>
          <Text variant="metadata" color="var(--dark-60)">
            {designStore?.file?.width}x{designStore?.file?.height}
          </Text>
        </div>
        {designFile.type === 'video' && (
          <div className={Styles.metadataItem}>
            <Text variant="metadata" color="var(--dark-60)">
              Length:
            </Text>
            <Text variant="metadata" color="var(--dark-60)">
              {durationLabel(designFile.duration)}
            </Text>
          </div>
        )}
        <div className={Styles.metadataItem}>
          <Text variant="metadata" color="var(--dark-60)">
            File size:
          </Text>
          <Text variant="metadata" color="var(--dark-60)">
            {bytesToMb(designFile.file.size).toFixed(2)}mb
          </Text>
        </div>
        <div className={Styles.metadataItem}>
          <Text variant="metadata" color="var(--dark-60)">
            Format:
          </Text>
          <Text variant="metadata" color="var(--dark-60)">
            {designFile.mime_type.split('/')[1].toUpperCase()}
          </Text>
        </div>
      </div>
      <div className={Styles.downloadIcon}>
        <Download size={24} />
      </div>
    </div>
  )
})
